module.exports = __webpack_public_path__ + "img/pr-5.8d68100a.png";